import React from 'react';
import { Link } from 'gatsby';
import './layout.css';
import { Helmet } from 'react-helmet';
import '@fortawesome/fontawesome-svg-core/styles.css';
import { config } from '@fortawesome/fontawesome-svg-core';

config.autoAddCss = false;

export default ({ children }) => {
  return (
    <div style={{height: '100%'}}>
      <Helmet>
        <title>Kotobako</title>
      </Helmet>

      <header style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginLeft: '10px', marginRight: '10px'}}>
        <Link to={'/'} style={logoStyle}>
          <h2 style={{marginTop: '10px', marginBottom: '20px'}}>Kotobako</h2>
        </Link>

        <Link to={'/about'} style={menuStyle}>about</Link>
        <Link to={'/works'} style={menuStyle}>works</Link>
      </header>
      {children}
    </div>
  );
};

const linkStyle = {
  textDecoration: 'none',
  color: '#444',
  fontFamily: 'Fredericka the Great',
}

const logoStyle = {
  ...linkStyle,
  justifySelf: 'flex-start',
  marginRight: 'auto',
  fontSize: '28px',
}

const menuStyle = {
  ...linkStyle,
  marginLeft: '14px',
  fontSize: '20px',
}
